<template>
  <v-app-bar
    app
    :elevation="elevation"
    :color="color"
    height="90"
  >
    <v-row
      no-gutters
      justify="space-between"
    >
      <v-col
        align-self="center"
        class="text-left"
      >
        <v-btn
          icon
          @click.stop="toggleNavDrawer"
        >
          <font-awesome-icon
            :icon="['fas', 'bars']"
            size="2x"
          />
        </v-btn>
        <router-link
          to="/"
        >
          <v-img
            :src="logoBar"
            alt="SorareMega logo"
            width="50"
            class="d-inline-block vertical-align-middle"
          />
        </router-link>
      </v-col>

      <v-col
        align-self="center"
        class="text-right"
      >
        <user-info
          class="vertical-align-middle"
        />
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import UserInfo from '@/components/AppBar/UserInfo.vue';
import logoBar from '@/assets/logo.svg';

export default {
  name: 'AppBar',
  components: {
    UserInfo,
  },
  data() {
    return {
      logoBar,
    };
  },
  props: {
    elevation: {
      type: String,
      default: '0',
    },
    color: {
      type: String,
      required: true,
    },
  },
  methods: {
    toggleNavDrawer() {
      this.$emit('toggleNavDrawer');
    },
  },
};
</script>
